export const UI_MAX_WIDTH = 1440;

export const MAX_ONBOARDING_PRICING_TIERS = 3;
